import { faqs } from '../data/siteData';
import { PageHero, FAQItem, CTASection } from '../components/UI';
import { WHATSAPP_URL, PHONE } from '../data/siteData';

const SvgIcon = ({ d, className = "w-5 h-5" }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d={d} />
  </svg>
);

const categories = [
  {
    label: 'General',
    icon: <SvgIcon className="w-5 h-5 text-teal" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />,
    indices: [0, 1, 2],
  },
  {
    label: 'Visa & Migration',
    icon: <SvgIcon className="w-5 h-5 text-teal" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />,
    indices: [3, 4],
  },
  {
    label: 'Documents & Process',
    icon: <SvgIcon className="w-5 h-5 text-teal" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />,
    indices: [5, 6],
  },
  {
    label: 'Costs & Booking',
    icon: <SvgIcon className="w-5 h-5 text-teal" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />,
    indices: [7, 8, 9],
  },
];

export default function FAQ({ setPage }) {
  return (
    <div>
      <PageHero
        breadcrumb="FAQ"
        title="Frequently Asked Questions"
        subtitle="Can't find your answer here? Contact us directly — our team responds within 2 hours."
      />

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">

            {/* Sidebar */}
            <div className="lg:col-span-1">
              <div className="bg-navy rounded-2xl p-7 sticky top-24">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 rounded-xl bg-teal/20 flex items-center justify-center">
                    <SvgIcon className="w-5 h-5 text-teal-light" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                  </div>
                  <h3 className="font-display text-xl text-white">Need More Help?</h3>
                </div>
                <p className="text-white/50 text-sm leading-relaxed mb-7">Our expert counselors are available to answer any specific questions about your personal situation.</p>
                <div className="flex flex-col gap-3">
                  <button
                    onClick={() => { setPage('contact'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                    className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-gold to-gold-light text-navy-deep font-bold text-sm px-5 py-3 rounded-xl hover:-translate-y-0.5 transition-all shadow-[0_4px_14px_rgba(201,168,76,0.35)]">
                    <SvgIcon className="w-4 h-4" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    Book Free Consultation
                  </button>
                  <a href={WHATSAPP_URL} target="_blank" rel="noreferrer"
                    className="w-full flex items-center justify-center gap-2 border-2 border-white/20 text-white font-semibold text-sm px-5 py-3 rounded-xl hover:border-white/40 hover:bg-white/5 transition-all">
                    <svg className="w-4 h-4 fill-white" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347"/></svg>
                    WhatsApp Us
                  </a>
                </div>

                <div className="mt-7 pt-6 border-t border-white/10 flex flex-col gap-3 text-sm">
                  <div className="flex items-center gap-2.5 text-white/45">
                    <SvgIcon className="w-4 h-4 text-teal/60" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    Mon–Sat: 9AM – 7PM PKT
                  </div>
                  <div className="flex items-center gap-2.5 text-white/45">
                    <SvgIcon className="w-4 h-4 text-teal/60" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 7V5z" />
                    {PHONE}
                  </div>
                  <div className="flex items-center gap-2.5 text-white/45">
                    <SvgIcon className="w-4 h-4 text-teal/60" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    Century Tower, Gulberg-3
                  </div>
                </div>
              </div>
            </div>

            {/* FAQ Categories */}
            <div className="lg:col-span-2">
              {categories.map(cat => (
                <div key={cat.label} className="mb-10">
                  <div className="flex items-center gap-3 mb-5 pb-3 border-b border-gray-100">
                    <div className="w-9 h-9 rounded-lg bg-teal/8 flex items-center justify-center">{cat.icon}</div>
                    <h3 className="font-body font-bold text-navy text-base">{cat.label}</h3>
                  </div>
                  {cat.indices.map(idx => faqs[idx] && <FAQItem key={faqs[idx].q} {...faqs[idx]} />)}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CTASection
        title="Still Have Questions?"
        subtitle="Our counselors are available to answer any specific questions about your situation. Just reach out."
        setPage={setPage}
      />
    </div>
  );
}
